import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  AppToastService,
  ToastMessage,
} from '../../services/app-toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './app-toast.component.html',
  styleUrls: ['./app-toast.component.scss'],
  standalone: false,
})
export class AppToastComponent implements OnInit, OnDestroy {
  toasts: ToastMessage[] = [];
  private subscription!: Subscription;

  constructor(private toastService: AppToastService) {}

  ngOnInit() {
    this.subscription = this.toastService.toastState$.subscribe((toast) => {
      this.toasts.unshift(toast);

      // NOVA LÓGICA DE TEMPO DE EXIBIÇÃO
      // Erros e Avisos ficam por 12 segundos (12000ms)
      // Sucesso e Info ficam por 5 segundos (5000ms)
      const duration = (toast.type === 'error' || toast.type === 'warning') ? 12000 : 5000;

      setTimeout(() => this.remove(toast.id), duration);
    });
  }

  remove(id: string) {
    const toast = this.toasts.find((t) => t.id === id);

    if (toast && !toast.isClosing) {
      toast.isClosing = true;

      setTimeout(() => {
        this.toasts = this.toasts.filter((t) => t.id !== id);
      }, 300);
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}